import { render, staticRenderFns } from "./dragpicture.vue?vue&type=template&id=4084f64c"
import script from "./dragpicture.vue?vue&type=script&lang=js"
export * from "./dragpicture.vue?vue&type=script&lang=js"
import style0 from "./dragpicture.vue?vue&type=style&index=0&id=4084f64c&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4084f64c')) {
      api.createRecord('4084f64c', component.options)
    } else {
      api.reload('4084f64c', component.options)
    }
    module.hot.accept("./dragpicture.vue?vue&type=template&id=4084f64c", function () {
      api.rerender('4084f64c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/upload/dragpicture.vue"
export default component.exports